<template>
  <NewsList/>
</template>
<script>
import NewsList from '@/components/modules/schoolroutes/news/list'
export default {
  name: 'news',
  components: {
    NewsList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/schoolroutes/news/list.vue